var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"p-5 w-50"},[_c('h1',[_vm._v("FrontEnd Testing")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.hasAlert)?_c('Alert',{attrs:{"alert":_vm.alert}}):_vm._e()],1),_vm._v(" "),_c('Downloads',{attrs:{"value":_vm.empty,"visibilities":_vm.downloadTypes || []}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }